function log(msg) {
    //console.log(msg);
}

function rawInput(data) {
  console.log('RECV: ' + data);
}

function rawOutput(data) {
  console.log('SENT: ' + data);
}
fourToldApp.factory('xmppAuth', function($rootScope, opefire, $cookieStore, $window, $interval, $localStorage, session, $mdDialog, $injector, cryptool, $location, services) {
    var Chat = {
        connection: null,
        connected: false,
        boshService: opefire,
        debugginMode: false,
        oneTimer: null,
        register: null,
        errorPing : 0,
        userName : $cookieStore.get('userName'),
        connect: function(jid, password) {
            Chat.debuggingMode = Chat.debugginMode ? Chat.debugginMode : true;
            Chat.connection = new Strophe.Connection(Chat.boshService, {'keepalive': true});//, 'auth_use_cache': false
            //Chat.connection.rawInput = rawInput;
            //Chat.connection.rawOutput = rawOutput;
            if ($window.localStorage.getItem("access_token1") == null) {
                Chat.connection.connect(jid + "/4TOLDCLIENT", password, Chat.onConnect);
                $localStorage.jid = jid;
            } else {
                try {
                    Chat.connection.restore($localStorage.jid, Chat.onConnect)
                } catch (e) {
                    if (e.name !== "StropheSessionError") {
                        throw e
                    }
                }
            }
        },
      reconnect: function(jid, password) {
          Chat.BOSH_SERVICE = Chat.boshService;
          Chat.debuggingMode = Chat.debugginMode ? Chat.debugginMode : true;
          Chat.connection = new Strophe.Connection(Chat.BOSH_SERVICE, {
              keepalive: true
          });
          Chat.connection.connect(jid + "/4TOLDCLIENT", password, Chat.onConnect)
      },
      disconnectAll: function() { 
        console.log("before disconnect")           
          if(Chat.connection) {
            Chat.connection.flush();
            Chat.connection.disconnect();
            console.log("disconnect...")
            Chat.connection.deleteHandler(Chat.receiveMessage);
            Chat.connection.deleteHandler(Chat.presenceReceived);
            Chat.connection.deleteTimedHandler(Chat.receiveMessage);
            Chat.connection.deleteTimedHandler(Chat.presenceReceived); 
            
          }
          $interval.cancel(Chat.oneTimer);
            Chat.oneTimer = null;
            Chat.connected = false;
      },
      disconnect: function() {          
          if(Chat.connection && Chat.connected) {
            Chat.connection.flush();
            Chat.connection.disconnect(); 
            Chat.connection.deleteHandler(Chat.receiveMessage);
            Chat.connection.deleteHandler(Chat.presenceReceived);
            Chat.connection.deleteTimedHandler(Chat.receiveMessage);
            Chat.connection.deleteTimedHandler(Chat.presenceReceived);
            //Chat.connection.ping.deletePingHandler(Chat.onPing);
            $interval.cancel(Chat.oneTimer);
            Chat.oneTimer = null;
            Chat.connected = false;
          }
      },
      delete_Handler: function() {
          if(Chat && Chat.connection) {        
            Chat.connection.flush();
            Chat.connection.deleteHandler(Chat.receiveMessage);
            Chat.connection.deleteHandler(Chat.presenceReceived);
            Chat.connection.deleteTimedHandler(Chat.receiveMessage);
            Chat.connection.deleteTimedHandler(Chat.presenceReceived);
            //Chat.connection.ping.deletePingHandler(Chat.onPing);
            //$interval.cancel(Chat.oneTimer);
            Chat.oneTimer = null;
            Chat.connected = false
            Chat.connection = undefined;
          }
      },
      session_logout: function(data){
        $rootScope.$broadcast("progresscircular", false);
        $cookieStore.remove("refresh_token");
        $window.localStorage.removeItem("access_token1");
        session.logout(data);
      },
      connectionStatus: 0,
      translateStatus : function(status){
            return Object.keys(Strophe.Status).find(key => Strophe.Status[key] === status)
      },
      onConnect: function(status) { 
        var date = new Date; 
        var seconds = date.getSeconds();
        var minutes = date.getMinutes();
        var hour = date.getHours();
        console.log(hour + " : " + minutes + " : " + seconds)
        
          console.log("onConnect " + Chat.translateStatus(status));
          if (status === Strophe.Status.CONNECTING) {
              log("Strophe is CONNECTING.")
              Chat.connectionStatus = 1;
          } else if (status === Strophe.Status.AUTHFAIL) {
                console.log("Strophe is AUTHFAIL.");
                Chat.session_logout();
                // $injector.get('$mdDialog').show({
                //     controller: 'msg_error_xmpp',
                //     templateUrl: location.origin + location.pathname + 'views/httpErrors/error-xmpp-authfail.html',
                //     size: 'md'
                //     });
          } else if (status === Strophe.Status.ERROR) {
                console.log("Strophe is Error.");
                Chat.session_logout();
                $injector.get('$mdDialog').show({
                    controller: 'msg_error_xmpp',
                    templateUrl: location.origin + location.pathname + 'views/httpErrors/error-xmpp-connfail-error.html',
                    size: 'md'
                    });
          } else if (status === Strophe.Status.DISCONNECTING) {
              log("Strophe is DISCONNECTING.")
          } else if (status === Strophe.Status.CONNFAIL) {
                log("Strophe is CONNFAIL.");
                Chat.connectionStatus = 0;
                if ($window.localStorage.getItem("access_token1") !== null){
                    //Chat.connection.deleteHandler(Chat.sendPing(Chat.connection.jid));
                    //Chat.connection.deleteTimedHandler(Chat.sendPing(Chat.connection.jid));
                    log("try reconnect.");
                    Chat.reconnect($window.sessionStorage.getItem("userXmpp") + "@" + cryptool.decryptData($window.sessionStorage.getItem("serviceName")), cryptool.decryptData($window.sessionStorage.getItem("passwordXmpp")))
                }
                else{
                    log("Strophe is DISCONNECTED2.");
                    $rootScope.$broadcast("DISCONNECTED", "DISCONNECTED");
                    Chat.delete_Handler();
                    session.logout();
                    $mdDialog.cancel();
            }
              
        } else if (status === Strophe.Status.DISCONNECTED) {
            
            if($localStorage.windowStatus == "background") {
                console.log("back for background");
                $localStorage.isDisconnected = "1" 
                if ($cookieStore.get("access_token") !== null){
                    Chat.connection.deleteHandler(Chat.sendPing(Chat.connection.jid));
                    Chat.connection.deleteTimedHandler(Chat.sendPing(Chat.connection.jid));
                    Chat.reconnect($window.sessionStorage.getItem("userXmpp") + "@" + cryptool.decryptData($window.sessionStorage.getItem("serviceName")), cryptool.decryptData($window.sessionStorage.getItem("passwordXmpp")))
                    console.log("reconnecting....");
                }
                return     
            }

            log("Strophe is DISCONNECTED.");
           if(Chat.connection) {
                Chat.connection = undefined;
                $mdDialog.cancel();
                Chat.session_logout(Chat.register);
           }

        } else if (status === Strophe.Status.ATTACHED) {
              log("Strophe is ATTACHED.");
              Chat.connected = true;
              Chat.sendPresence();
              var iq = $iq({
                  type: "get"
              }).c("query", {
                  xmlns: "jabber:iq:roster"
              });
              /*Chat.oneTimer = $interval(function() {
                  Chat.sendPing(Chat.connection.jid)
              }, 1 * 2e4);*/
              Chat.connection.sendIQ(iq, Chat.your_roster_callback_function);
              Chat.rosterReceived(iq);
              Chat.sendPing1(Chat.connection.jid)
              Chat.connection.addHandler(Chat.presenceReceived, null, "presence");
              Chat.connection.addHandler(Chat.receiveMessage, null, "message");
              Chat.connection.addHandler(Chat.on_error_iq, null, 'iq', 'error');
              Chat.connection.ping.addPingHandler(Chat.onPing);
              Chat.discoInfo(Chat.connection.jid);
              Chat.discoverNodes();
          }else if (status === Strophe.Status.CONNECTED) {
              log("Strophe is connected.");
              $localStorage.windowStatus == "front"
              $rootScope.$broadcast("iconConnected", "CONNECTED");
              Chat.connected = true;
              Chat.sendPresence();
              var iq = $iq({
                  type: "get"
              }).c("query", {
                  xmlns: "jabber:iq:roster"
              });
              /*Chat.oneTimer = $interval(function() {
                  Chat.sendPing(Chat.connection.jid)
              }, 1 * 2e4);*/
              Chat.connection.sendIQ(iq, Chat.your_roster_callback_function);
              Chat.rosterReceived(iq);
              Chat.sendPing1(Chat.connection.jid)
              Chat.connection.addHandler(Chat.presenceReceived, null, "presence");
              Chat.connection.addHandler(Chat.receiveMessage, null, "message");
              Chat.connection.addHandler(Chat.on_error_iq, null, 'iq', 'error');
              Chat.connection.ping.addPingHandler(Chat.onPing);
              Chat.discoInfo(Chat.connection.jid);
              Chat.discoverNodes(); 
              //Chat.getSubscriptions();
          }
      },    
    your_roster_callback_function: function (iq){
        $(iq).find('item').each(function(){
          var jid = $(this).attr('jid');
        //  console.log("your_roster_callback_function " + jid)
        });
        Chat.connection.deleteHandler(Chat.presenceReceived);
        Chat.connection.addHandler(Chat.presenceReceived, null, "presence");
        Chat.connection.send($pres());
    },
    sendPriority: function (priority) {
    Chat.connection.send($pres()
            .c("priority").t(priority));
    console.log("Priority of " + priority + " sent to contacts.");
    },
    sendPresence: function () {
        try{
            Chat.connection.send($pres());
        }catch(err) {
        }
    },
    messages: [],
    chatStates: {},

    receiveACK: function(msg){
      $rootScope.$broadcast('msgRecievedBroadcast', msg.getAttribute("id"), "ack");
      $rootScope.$broadcast('msgRecievedBroadcastChannel', msg.getAttribute("id"), "ack");
    },
    on_error_iq: function(stanza){
      //console.log(stanza);
      return true;
    },
    receiveMessage: function (msg) {
      //Chat.log("message received: ", msg);
      var received = msg.getElementsByTagName("received");
      if(received[0]) {
        Chat.receiveACK(received[0]);
        return true;
      }
      else if (from === Chat.pubsubJid && msg.getElementsByTagName('summary').length) {
            Chat.log("pubsub message", msg.getElementsByTagName('summary')[0]);
            var items = msg.getElementsByTagName('items');
            var nodeName = items[0].getAttribute('node');
            Chat.pubsubMessages.push({
                "message": Strophe.getText(msg.getElementsByTagName('summary')[0]),
                "type": "received",
                "nodeName": nodeName
            });
        }
        else if (msg.getElementsByTagName('paused').length) {
            Chat.log("Sender is Paused");
            Chat.chatStates[from] = "paused";
        }
        /*else if (msg.getElementsByTagName('active').length) {
            Chat.log("Sender is Active");
            Chat.chatStates[from] = "active";
        }*/
        else if (msg.getElementsByTagName('composing').length) {
            Chat.log("Sender is composing");
            Chat.chatStates[from] = "composing"
            if($localStorage.chatState === "composing")
              $rootScope.$broadcast('msgRecievedBroadcast', "composing", "composing");
        }
        else if (msg.getElementsByTagName('body').length) {
            var from = msg.getAttribute('from');
            var elems = $(msg).find('body').text();
            var message = {};
            if (elems.length > 0) {
                elems = JSON.parse(elems);
                if(elems.alternateChannel && elems.alternateChannel !== null){
                    if($localStorage.channel){
                        message = {alternateChannel: elems.alternateChannel, text: elems.body.message, body: elems.body,date: new Date(elems.body.timestamp), metadataObj: elems.metadata, metadata: elems.metadata, id: elems.body.id, layout: "start", isAction: (elems.type === "ACTION")};
                        var channel_exists = $localStorage.channel.find( data => data.alternateChannel === elems.alternateChannel)
                        if(channel_exists && channel_exists.body){
                            if(elems.type && elems.body.message !== 'HelpFirstLoan' || (elems.metadata.instruction && !elems.metadata.instruction.hideText)) {
                                $localStorage.chatState = "body";
                                message = {text: elems.body.message, body: elems.body,date: new Date(elems.body.timestamp), metadataObj: elems.metadata, metadata: elems.metadata, id: elems.body.id, layout: "start", isAction: (elems.type === "ACTION")};
                                if(elems.metadata!=null && elems.metadata.help!=null && elems.metadata.instruction!=null && elems.metadata.instruction.silent === true){
                                      $rootScope.$broadcast('msgRecievedBroadcastHelp', message);
                                  }
                                  else{
                                      if(elems.metadata.processControl)
                                          $window.localStorage.setItem('aga_status', JSON.stringify(elems));
                                      else if(!elems.metadata.processControl && $window.localStorage.getItem('aga_status'))
                                          $window.localStorage.removeItem('aga_status');    
    
                                        channel_exists.body.push(message);
                                        $rootScope.$broadcast('msgRecievedBroadcastChannel', message);
                                        $rootScope.$broadcast('msgUnread', elems.alternateChannel);
                                        if(elems.metadata.help && elems.metadata.constraints == null)
                                            $rootScope.$broadcast('msgRecievedBroadcastHelp', message);
                                }
                            }
                        }else if(channel_exists && !channel_exists.body){
                            $rootScope.$broadcast('msgUnread', elems.alternateChannel);
                        }
                        else if(!channel_exists){
                            message = {alternateChannel: elems.alternateChannel, text: elems.body.message, body: elems.body,date: new Date(elems.body.timestamp), metadataObj: elems.metadata, metadata: elems.metadata, id: elems.body.id, layout: "start", isAction: (elems.type === "ACTION")};
                            var objMsg = {
                                "alternateChannel": elems.alternateChannel,
                                "alternateChannelId":  elems.alternateChannelId,
                                "body": [message],
                                "unread": 1
                            }
                            $rootScope.$broadcast('msgChannel', objMsg);
                        }
                    }else {
                        message = {alternateChannel: elems.alternateChannel, text: elems.body.message, body: elems.body,date: new Date(elems.body.timestamp), metadataObj: elems.metadata, metadata: elems.metadata, id: elems.body.id, layout: "start", isAction: (elems.type === "ACTION")};
                        var objMsg = {
                            "alternateChannel": elems.alternateChannel,
                            "alternateChannelId":  elems.alternateChannelId,
                            "body": [message],
                            "unread": 1
                        }
                        $rootScope.$broadcast('msgChannel', objMsg);
                    }
                }
                if(elems.body.constraints && elems.body.constraints.operation){
                    var message = {text: elems.body.message, body: elems.body,date: new Date(elems.body.timestamp), id: elems.body.id, layout: "start", isAction: (elems.type === "ACTION"), fromJabberId: elems.fromJabberId};
                    var channel_exists = $localStorage.channel.find( data => data.alternateChannelId === elems.fromJabberId)
                    if($localStorage.channel){
                        if(channel_exists && channel_exists.body){
                            if(elems.type && elems.body.message !== 'HelpFirstLoan' || (elems.metadata.instruction && !elems.metadata.instruction.hideText)) {
                                $localStorage.chatState = "body";
                                message = {text: elems.body.message, body: elems.body,date: new Date(elems.body.timestamp), id: elems.body.id, layout: "start", isAction: (elems.type === "ACTION"), fromJabberId: elems.fromJabberId};
                                channel_exists.body.push(message);
                                if(elems.body.constraints.operation === "FINISH"){
                                    //$rootScope.$broadcast('msgRecievedBroadcastChannel', message, "FINISH");
                                    $rootScope.$broadcast('msgChannel', message, "FINISH");
                                }
                                $rootScope.$apply();
                                $rootScope.$broadcast('msgUnread', elems.fromJabberId);
                            }
                        }
                        else if(!channel_exists){
                            var objMsg = {
                                "alternateChannel": "Soporte Hola Prestamo",
                                "alternateChannelId":  elems.fromJabberId,
                                "body": [message],
                                "unread": 1
                            }
                            $rootScope.$broadcast('msgChannel', objMsg);
                        }
                    }
                }
                else{ // CANAL PRINCIPAL
                    if(elems.type && elems.body.message !== 'HelpFirstLoan' || (elems.metadata.instruction && !elems.metadata.instruction.hideText)) {
                        $localStorage.chatState = "body";
                        message = {text: elems.body.message, body: elems.body,date: new Date(elems.body.timestamp), metadataObj: elems.metadata, metadata: elems.metadata, id: elems.body.id, layout: "start", isAction: (elems.type === "ACTION")};
                        if(elems.metadata!=null && elems.metadata.help!=null && elems.metadata.instruction!=null && elems.metadata.instruction.silent === true){
                              $rootScope.$broadcast('msgRecievedBroadcastHelp', message);
                          }
                          else{
                              if(elems.metadata.processControl)
                                  $window.localStorage.setItem('aga_status', JSON.stringify(elems));
                              else if(!elems.metadata.processControl && $window.localStorage.getItem('aga_status'))
                                  $window.localStorage.removeItem('aga_status'); 
                                  
                                if($localStorage.msg)
                                    $localStorage.msg.push(message);
                                else{
                                    var msgArray = [{text: elems.body.message, body: elems.body,date: new Date(elems.body.timestamp), metadataObj: elems.metadata, metadata: elems.metadata, id: elems.body.id, layout: "start", isAction: (elems.type === "ACTION")}]
                                    $localStorage.msg = msgArray;
                                }

                                //$window.localStorage.setItem('metadataObj', JSON.stringify(message.metadataObj));
                                message["isNew"] = true;
                                $window.sessionStorage.setItem("uploadRetry", "0");  
                                $rootScope.$broadcast('msgRecievedBroadcast', message);
                                $rootScope.$broadcast('msgUnread', "dashboard");
                                if(elems.metadata.help && elems.metadata.constraints == null)
                                    $rootScope.$broadcast('msgRecievedBroadcastHelp', message);
                        }
                    }
                } 
            }
        }
        return true;
    },
    sendMessage: function (from, message, messageValue, type, data, id, domain, alternateChannelId, alternateChannel, additionalEntityValues) {
        var date = new Date();
        var timestamp = date.getTime();
        var timeString = timestamp.toString(); 
        var to = cryptool.decryptData($window.sessionStorage.getItem("openfireContactServer"));
         
        $window.sessionStorage.removeItem("confirmDialog");
        if(alternateChannelId === undefined){
            alternateChannelId = null;
            alternateChannel = null;
        }
        if(id === undefined)
            id = timeString;

            var answered;
            var replyType;
            var sessionType = null;

        if($window.sessionStorage.getItem("replyType")){
            answered = true;
            replyType = "RETRY";
        }
        else{
            answered = false;
            replyType = "REPLY";
        }
        
        if($window.sessionStorage.getItem("sessionType"))
            sessionType = $window.sessionStorage.getItem("sessionType");

        var obj = {"alwaysRetry":false,"answered":answered,"body":{"id": id,"message": messageValue,"replyType":replyType, "timestamp":timestamp,"value": message}, "clientInterface":"WEB" ,"fromJabberId":from,"id": timeString,"read":false,"toJabberId":to, "type": data, "alternateChannelId": alternateChannelId, "alternateChannel": alternateChannel,  "sessionType": sessionType};

        if (additionalEntityValues){
            obj.body.entityValues = JSON.stringify(additionalEntityValues);
        }

        if($window.localStorage.getItem("metadataObj") && $window.localStorage.getItem("metadataObj") !== "undefined"){
            var metadataObj = JSON.parse($window.localStorage.getItem("metadataObj"));
            if(metadataObj.instruction!=null  && metadataObj.instruction.gps!=null  && $window.sessionStorage.getItem("entityValues") !=null){
                var entityValues = $window.sessionStorage.getItem("entityValues");
                var obj = {"alwaysRetry":false,"answered":answered,"body":{"id": id,"message": messageValue,"replyType":replyType, "timestamp":timestamp,"value": message, "entityValues":entityValues}, "clientInterface":"WEB" ,"fromJabberId":from,"id": timeString,"read":false,"toJabberId":to, "type": data, "alternateChannelId": alternateChannelId, "alternateChannel": alternateChannel,  "sessionType": sessionType};
            }
        }
            

       
        var myobj = JSON.stringify(obj);

        if($location.search().offline) { 
            services.offline('bearer ' + $window.localStorage.getItem('access_token1')).sendData({}, myobj,  function(response) {
                console.log(response)                    
            })
            
            $window.sessionStorage.removeItem("replyType");
            $localStorage.chatState = "composing";

            message = {text: messageValue, date: date, type: type, user: Chat.userName, layout: "end", id: id, icon: "check.png", ack: true, obj: obj, "clientInterface":"WEB"};
            $rootScope.$broadcast('msgRecievedBroadcast', message);
            $rootScope.$broadcast('msgRecievedBroadcastChannel', message);
            $window.sessionStorage.removeItem("entityValues"); 
        }

        try {
          if (message!== undefined && to && !$location.search().offline) {
              var reply = $msg({
                      to: to,
                      from: Chat.connection.jid,
                      type: 'chat',
                      id: Chat.connection.getUniqueId()
                  })
                  .cnode(Strophe.xmlElement('body', myobj)).up()
                      .c('active', {
                          xmlns: "urn:xmpp:receipts"
                  });
                  Chat.connection.receipts.sendMessage(reply);
                  //console.log('I sent : ' + message, reply.tree());
                  $window.sessionStorage.removeItem("replyType");
                  $localStorage.chatState = "composing";

                  message = {text: messageValue, date: date, type: type, user: Chat.userName, layout: "end", id: reply.tree().getAttribute("id"), icon: "check.png", ack: false, obj: obj, "clientInterface":"WEB"};
                  $rootScope.$broadcast('msgRecievedBroadcast', message);
                  $rootScope.$broadcast('msgRecievedBroadcastChannel', message);
                  $window.sessionStorage.removeItem("entityValues"); 
            }
        }
        catch(err) {
            console.log(err);
            alert("Ocurrio un error al momento de enviar la información. Intente nuevamente");
        }

        return true;
    },
    sendMessageInBlock: function (from, message, messageValue, formatedMessageInBlock,type, data, id, alternateChannelId, alternateChannel) {
        var date = new Date();
        var timestamp = date.getTime();
        var timeString = timestamp.toString(); 
        var sessionType = null;
        var to = cryptool.decryptData($window.sessionStorage.getItem("openfireContactServer"));  
        $window.sessionStorage.removeItem("confirmDialog");
        if(id === undefined)
            id = timeString;
            
        if($window.sessionStorage.getItem("sessionType"))
            sessionType = $window.sessionStorage.getItem("sessionType");
            
            var entityValues = null;
            if($window.localStorage.getItem("metadataObj") && $window.localStorage.getItem("metadataObj") !== "undefined"){
                var metadataObj = JSON.parse($window.localStorage.getItem("metadataObj"));
                if(metadataObj.instruction!=null  && metadataObj.instruction.gps!=null  && $window.sessionStorage.getItem("entityValues") !=null){
                    entityValues = $window.sessionStorage.getItem("entityValues");                    
                }
            }
       
       
            if($window.sessionStorage.getItem("replyType"))
          var obj = {"alwaysRetry":false,"answered":true,"body":{"id": id,"message": message, "replyType":"RETRY", "timestamp":timestamp,"value": messageValue, "entityValues":entityValues,"formatedMessageInBlock":formatedMessageInBlock}, "clientInterface":"WEB" ,"fromJabberId":from,"id": timeString,"read":false,"toJabberId":to, "type": data, "alternateChannelId": alternateChannelId, "alternateChannel": alternateChannel, "sessionType": sessionType};
        else var obj = {"alwaysRetry":false,"answered":false,"body":{"id": id,"message": message,"replyType":"REPLY", "timestamp":timestamp,"value": messageValue, "entityValues":entityValues,"formatedMessageInBlock":formatedMessageInBlock}, "clientInterface":"WEB" ,"fromJabberId":from,"id": timeString,"read":false,"toJabberId":to, "type": data, "alternateChannelId": alternateChannelId, "alternateChannel": alternateChannel, "sessionType": sessionType};

       
       
       
        var myobj = JSON.stringify(obj);
        if($location.search().offline) { 
            services.offline('bearer ' + $window.localStorage.getItem('access_token1')).sendData({}, myobj,  function(response) {

            })
            
            $window.sessionStorage.removeItem("replyType");
            $localStorage.chatState = "composing";
            message = {text: message, date: date, type: type, user: Chat.userName, layout: "end", id: id, icon: "check.png", ack: true, obj: obj, "clientInterface":"WEB"};
            $rootScope.$broadcast('msgRecievedBroadcast', message);
            $rootScope.$broadcast('msgRecievedBroadcastChannel', message);
            $window.sessionStorage.removeItem("entityValues"); 
        }


        try {
          if (message!== undefined && to && !$location.search().offline) {
              var reply = $msg({
                      to: to,
                      from: Chat.connection.jid,
                      type: 'chat',
                      id: Chat.connection.getUniqueId()
                  })
                  .cnode(Strophe.xmlElement('body', myobj)).up()
                      .c('active', {
                          xmlns: "urn:xmpp:receipts"
                  });
                  Chat.connection.receipts.sendMessage(reply);
                  //console.log('I sent : ' + message, reply.tree());
                  $window.sessionStorage.removeItem("replyType");
                  $localStorage.chatState = "composing";
                  message = {text: message, date: date, type: type, user: Chat.userName, layout: "end", id: reply.tree().getAttribute("id"), icon: "check.png", ack: false, obj: obj, "clientInterface":"WEB"};
                  $rootScope.$broadcast('msgRecievedBroadcast', message);
                  $rootScope.$broadcast('msgRecievedBroadcastChannel', message);
                  $window.sessionStorage.removeItem("entityValues"); 
            }
        }
        catch(err) {
            console.log(err);
            alert("Ocurrio un error al momento de enviar la información. Intente nuevamente");
        }
        return true;
    },
    sendMessagePeerToPeer: function (from, to, msg, type, data) {
        var date = new Date();
        var timestamp = date.getTime();
        var timeString = timestamp.toString(); 
        var id = timeString;

        var sessionType = null;

        if($window.sessionStorage.getItem("sessionType"))
         sessionType = $window.sessionStorage.getItem("sessionType");
            
        if($window.sessionStorage.getItem("replyType"))
          var obj = {"alwaysRetry":false,"answered":true,"body":{"id": id,"message": msg, "sendStatus": 0, "timestamp":timestamp,"value": msg}, "clientInterface":"WEB" ,"fromJabberId":from,"id": timeString,"read":false,"toJabberId":to, "type": data, "sessionType": sessionType};
        else var obj = {"alwaysRetry":false,"answered":false,"body":{"id": id,"message": msg,"sendStatus": 0, "timestamp":timestamp,"value": msg}, "clientInterface":"WEB" ,"fromJabberId":from,"id": timeString,"read":false,"toJabberId":to, "type": data, "sessionType": sessionType};
        var myobj = JSON.stringify(obj);

        try {
          if (msg!== undefined && to) {
              var reply = $msg({
                      to: to,
                      from: Chat.connection.jid,
                      type: 'chat',
                      id: Chat.connection.getUniqueId()
                  })
                  .cnode(Strophe.xmlElement('body', myobj)).up()
                      .c('active', {
                          xmlns: "urn:xmpp:receipts"
                  });
                  Chat.connection.receipts.sendMessage(reply);
                  console.log('I sent : ' + msg, reply.tree());
                  $window.sessionStorage.removeItem("replyType");
                  $localStorage.chatState = "composing";
                  message = {text: msg, date: date, type: type, user: Chat.userName, layout: "end", id: reply.tree().getAttribute("id"), icon: "check.png", ack: false, obj: obj, "clientInterface":"WEB"};
                  $rootScope.$broadcast('msgRecievedBroadcastChannel', message);
            }
        }
        catch(err) {
            alert("Ocurrio un error al momento de enviar la información. Intente nuevamente");
        }
        return true;
    },
    retrySendMessage: function(data, domain){
      var to = cryptool.decryptData($window.sessionStorage.getItem("openfireContactServer"));
      var myobj = JSON.stringify(data.obj);
      $window.sessionStorage.removeItem("confirmDialog");
      try {
        if (data!== undefined && to) {
            var reply = $msg({
                    to: to,
                    from: Chat.connection.jid,
                    type: 'chat',
                    id: Chat.connection.getUniqueId()
                })
                .cnode(Strophe.xmlElement('body', myobj)).up()
                    .c('active', {
                        xmlns: "urn:xmpp:receipts"
                });
                Chat.connection.receipts.sendMessage(reply);
                $localStorage.chatState = "composing";
                data.id = reply.tree().getAttribute("id");
                data.icon = "check.png";
                data.ack = false;
          }
      }
      catch(err) {
          alert("Ocurrio un error al momento de enviar la información. Intente nuevamente");
      }
      return true;
    },
    sendDeliveredMarker: function(to, from, originalMessageId) {
         var stanzaParams = {
             type: 'chat',
             from: from,
             id: "<id>",
             to: to
         };

         var messageStanza = $msg(stanzaParams);
         messageStanza
             .c('received', {
                 xmlns: "urn:xmpp:chat-markers:0",
                 id: originalMessageId
             })
             .up();

         Chat.connection.send(messageStanza);
   },
   sendSkipMsg: function (from, type, data, id, domain) {
        var date = new Date();
        var timestamp = date.getTime();
        var timeString = timestamp.toString(); 
        var to = cryptool.decryptData($window.sessionStorage.getItem("openfireContactServer"));

        if(id === undefined)
            id = timeString;

        var sessionType = null;
        if($window.sessionStorage.getItem("sessionType"))
            sessionType = $window.sessionStorage.getItem("sessionType");

        var obj = {"alwaysRetry":false,"answered":true,"body":{"id": id,"message": null, "replyType": "SKIP", "timestamp":timestamp,"value": null}, "clientInterface":"WEB" ,"fromJabberId":from,"id": timeString,"read":false,"toJabberId": to, "type": data, "alternateChannelId": $localStorage.identification_channel.alternateChannelId, "alternateChannel": $localStorage.identification_channel.alternateChannel, "sessionType": sessionType};
        var myobj = JSON.stringify(obj);

        if (to) {
          var reply = $msg({
                  to: to,
                  from: Chat.connection.jid,
                  type: 'chat',
                  id: Chat.connection.getUniqueId()
              })
              .cnode(Strophe.xmlElement('body', myobj)).up()
                  .c('active', {
                      xmlns: "urn:xmpp:receipts"
              });
            Chat.connection.send(reply.tree());
        }
    },
    sendMessageImage: function (from, type, id, domain, message, value) {
        var date = new Date();
        var timestamp = date.getTime();
        var timeString = timestamp.toString(); 
        var to = cryptool.decryptData($window.sessionStorage.getItem("openfireContactServer"));
        var sessionType = null;
        var attachmentPath= "/storage/emulated/0/4told/"+timeString+"."+ message.format;
        message.date = date;
        
        var replyType = $window.sessionStorage.getItem("replyType") ? "RETRY" : "REPLY";
        $window.sessionStorage.removeItem("replyType");

        $window.sessionStorage.removeItem("confirmDialog");
        var entityValues = null;

        if($window.sessionStorage.getItem("sessionType"))
            sessionType = $window.sessionStorage.getItem("sessionType");

        if($window.localStorage.getItem("metadataObj") && $window.localStorage.getItem("metadataObj") !== "undefined"){
            var metadataObj = JSON.parse($window.localStorage.getItem("metadataObj"));
            if(metadataObj.instruction!=null  && metadataObj.instruction.gps!=null  && $window.sessionStorage.getItem("entityValues") !=null){
                entityValues = $window.sessionStorage.getItem("entityValues");
            }
        }

        var obj={
            "alwaysRetry":false,
            "answered":false,
            "attachmentPath":attachmentPath,
            "body":{
                "id":id,
                "message": message.text,
                "timestamp":timestamp,
                "value": value,
                "replyType": replyType,
                "entityValues":entityValues
        },
            "clientInterface":"WEB",
            "fromJabberId":from,
            "id":timeString,
            "read":false,
            "toJabberId":to,
            "type":type,
            "alternateChannelId": $localStorage.identification_channel.alternateChannelId, 
            "alternateChannel": $localStorage.identification_channel.alternateChannel,
            "sessionType": sessionType
        };
        var myobj = JSON.stringify(obj);

        if($location.search().offline) { 
            services.offline('bearer ' + $window.localStorage.getItem('access_token1')).sendData({}, myobj,  function(response) {

            })
            
            $window.sessionStorage.removeItem("replyType");
            $localStorage.chatState = "composing";
         
            $rootScope.$broadcast('msgRecievedBroadcast', message);
            $rootScope.$broadcast('msgRecievedBroadcastChannel', message);
            $window.sessionStorage.removeItem("entityValues"); 
        }

        try {
          if (message!== undefined && to && !$location.search().offline) { 
           
            var reply = $msg({
                to: to,
                from: Chat.connection.jid,
                type: 'chat',
                id: Chat.connection.getUniqueId()
                })
                .cnode(Strophe.xmlElement('body', myobj)).up()
                .c('active', {
                    xmlns: "urn:xmpp:receipts"
                });
                Chat.connection.receipts.sendMessage(reply);
                message.id = reply.tree().getAttribute("id");
                message.icon = "check.png";
                message.ack = false;
                message.obj = obj;
                $rootScope.$broadcast('msgRecievedBroadcast', message);
                $rootScope.$broadcast('msgRecievedBroadcastChannel', message);
                $window.sessionStorage.removeItem("entityValues"); 
                
            }
        }
        catch(err) {
            alert("Ocurrio un error al momento de enviar la información. Intente nuevamente");
        }
    },

    sendMessageDate: function (messgeFrom, dateFormat, dateString, type, data, id, domain) {
        var date = new Date();
        var timestamp = date.getTime();
        var timeString = timestamp.toString(); 
        var to = cryptool.decryptData($window.sessionStorage.getItem("openfireContactServer"));
        var sessionType = null;
        $window.sessionStorage.removeItem("confirmDialog");
        if(id === undefined)
            id = timeString;
            
        var replyType = $window.sessionStorage.getItem("replyType") ? "RETRY" : "REPLY";
        $window.sessionStorage.removeItem("replyType");
        
        if($window.sessionStorage.getItem("sessionType"))
            sessionType = $window.sessionStorage.getItem("sessionType");

        var entityValues = null;
        if($window.localStorage.getItem("metadataObj") && $window.localStorage.getItem("metadataObj") !== "undefined"){
            var metadataObj = JSON.parse($window.localStorage.getItem("metadataObj"));
            if(metadataObj.instruction!=null  && metadataObj.instruction.gps!=null  && $window.sessionStorage.getItem("entityValues") !=null){
                entityValues = $window.sessionStorage.getItem("entityValues");
            }
        }

        var obj={
            "alwaysRetry":false,
            "answered":false,
            "body":{
                "id":id,
                "message":dateString,
                "messageToShowInChat":dateFormat,
                "timestamp":timestamp,
                "value":dateString,
                "replyType":replyType,
                "entityValues":entityValues
            },
            "clientInterface":"WEB",
            "fromJabberId":messgeFrom,
            "id":timeString,
            "read":false,
            "toJabberId": to,
            "type":data,
            "alternateChannelId": $localStorage.identification_channel.alternateChannelId, 
            "alternateChannel": $localStorage.identification_channel.alternateChannel,
            "sessionType": sessionType
        };

        var myobj = JSON.stringify(obj);
        
        if($location.search().offline) { 
            services.offline('bearer ' + $window.localStorage.getItem('access_token1')).sendData({}, myobj,  function(response) {

            })
            
            $window.sessionStorage.removeItem("replyType");
            $localStorage.chatState = "composing";
            message = {text: dateFormat, date: date, type: type, user: Chat.userName, layout: "end", id: id, icon: "check.png", ack: true, obj: obj, "clientInterface":"WEB"};
            $rootScope.$broadcast('msgRecievedBroadcast', message);
            $rootScope.$broadcast('msgRecievedBroadcastChannel', message);
            $window.sessionStorage.removeItem("entityValues"); 
        } else { 
            var reply = $msg({
                to: to,
                type: 'chat',
                id: Chat.connection.getUniqueId()
            })
                .cnode(Strophe.xmlElement('body', myobj)).up()
                .c('active', {
                    xmlns: "urn:xmpp:receipts"
                });

            Chat.connection.receipts.sendMessage(reply);
            var message = {text: dateFormat, date: date, type: type, user: Chat.userName, layout: "end", id: reply.tree().getAttribute("id"), icon: "check.png", ack: false, obj: obj};
            $rootScope.$broadcast('msgRecievedBroadcast', message);
            $rootScope.$broadcast('msgRecievedBroadcastChannel', message);
            $window.sessionStorage.removeItem("entityValues"); 
        }
    },
    Roster: [],
      getRoster: function () {
          if (!Chat.Roster) {
              Chat.log("Roster Items not yet loaded!/No Contacts");
          }
          else
              return Chat.Roster;
      },
    rosterReceived: function (iq) {
          Chat.log(iq);
          $(iq).find("item").each(function () {
              Chat.Roster.push({jid: $(this).attr('jid'),
                  name: $(this).attr('name'),
                  subscription: $(this).attr('subscription')
              });
          });
          Chat.connection.addHandler(Chat.presenceReceived, null, "presence");
      },

      unauthorizeUser: function (Jid, message) {
          if (Chat.userExists(Jid)) {
              Chat.connection.roster.unauthorize(Jid, message);
              Chat.log("Unauthorized: " + Jid);
          } else
              Chat.log("Error Unauthorizing");

      },
      presenceMessage: {},
      presenceReceived: function (presence) {
          var presence_type = $(presence).attr('type'); // unavailable, subscribed, etc...
          var from = $(presence).attr('from'); // the jabber_id of the contact...
          if (!Chat.presenceMessage[from])
              Chat.log(presence);
          if (presence_type !== 'error') {
              if (presence_type === 'unavailable') {
                  Chat.log("Contact: ", $(presence).attr('from'), " is offline");
                  Chat.log("here offline");
                  Chat.presenceMessage[from] = "offline";
                  var token = $window.localStorage.getItem('access_token1');
                  if(from.includes(".aga") && token) {
                    $rootScope.$broadcast('agaUserDisconnected', {user: from});       
                  } else if(Chat.connected){
                    Chat.disconnect();    
                  }
                  
              } else {
                  var show = $(presence).find("show").text(); // this is what gives away, dnd, etc.
                  if ((show === 'chat' || show === '') && (!Chat.presenceMessage[from])) {
                      // Mark contact as online
                      Chat.log("Contact: ", $(presence).attr('from'), " is online");
                      //console.log("Contact: ", $(presence).attr('from'), " is online");
                      Chat.presenceMessage[from] = "online";
                      Chat.sendPresence();
                  } else if (show === 'away') {
                      Chat.log("Contact: ", $(presence).attr('from'), " is offline");
                      Chat.presenceMessage[from] = "offline";
                  }
              }
          }
          return true;
      },
      sendChatState: function (Jid, status, type) {
          var chatType = (type) ? type : "chat";
          if (Chat.connection && Jid) {
              Chat.connection.chatstates.init(Chat.connection);
              if (status === "active") {
                  Chat.connection.chatstates.sendActive(Jid, chatType);
              } else if (status === "composing") {
                  Chat.connection.chatstates.sendComposing(Jid, chatType);
              } else if (status === "paused") {
                  Chat.connection.chatstates.sendPaused(Jid, chatType);
              } else
                  Chat.log("Error, try again");

          } else {
              Chat.log("Error,sorry not connected")
          }
      },
      discoSuccess: {},
      sendPing1 : function(jid){
        Chat.connection.ping.ping(
            jid,
            function (iq) {Chat.onPong(iq);},
            function () { console.log('Failed!'); }, 
            3000);
        },
      sendPing : function(jid){
            Chat.connection.ping.ping(
                jid,
                function (success_callback){
                  Chat.onPing(success_callback)
                },
                function (error_callback) {
                },
              3000);
        },
        onPing: function(iq) {
            Chat.connection.ping.pong(iq);
            return true
        },
        onPong: function(iq) {
            return false
        },
        discoInfo: function(Jid) {
            Chat.connection.disco.info(Jid, "", function(status) {
                //console.log("Disc Info Success", status);
                Chat.discoSuccess[Jid] = true
            }, function(status) {
                //console.log("Disc Info Error", status);
                Chat.discoSuccess[Jid] = false
            })
        },
        Pings: {},
        ping: function(Jid) {
            Chat.connection.ping.ping(Jid, function(status) {
                Chat.log("Ping Success", status);
                Chat.Pings[Jid] = true
            }, function(status) {
                Chat.log("Ping Error", status);
                Chat.Pings[Jid] = false
            })
        },
        discoverNodes: function() {
            Chat.connection.pubsub.discoverNodes(function(iq) {
                $(iq).find("item").each(function() {
                    Chat.pubsubNodes.push($(this).attr("node"));
                    if (!Chat.pubsubJid) {
                        Chat.pubsubJid = $(this).attr("jid");
                    }
                });
                Chat.log("success retreiving nodes, stored in array Chat.pubsubNodes", iq)
            }, function(status) {
                Chat.log("error", status)
            })
        },
        pubsubNodes: [],
        pubsubJid: false,
        pubsubMessages: [],
        pubsubPublish: function(nodeName, message) {
            Chat.connection.pubsub.publish(nodeName, message, Chat.onPublish);
            Chat.pubsubMessages.push({
                message: message,
                type: "sent",
                nodeName: nodeName
            })
        },
        onPublish: function(status) {
            Chat.log("Message published", status);
            return true
        },
        subscribedNodes: [],
        getSubscriptions: function() {
            Chat.connection.pubsub.getSubscriptions(function(status) {
                Chat.log("Got Subscriptions, stored in Chat.subscribedNodes");
                $(status).find("subscription").each(function() {
                    Chat.subscribedNodes.push($(this).attr("node"))
                })
            })
        },
        getNodeSubscriptions: function(nodeName) {
            var subscribers = [];
            Chat.connection.pubsub.getNodeSubscriptions(nodeName, function(status) {
                Chat.log("Got all subscribers to the node", status);
                $(status).find("subscription").each(function() {
                    subscribers.push($(this).attr("jid"))
                })
            });
            return subscribers
        },
        mucSendPresence: function(roomName) {
            var presence = $pres({
                to: roomName
            }).c("x", {
                xmlns: "http://jabber.org/protocol/muc"
            });
            Chat.log(presence.tree());
            Chat.connection.send(presence.tree())
        },
        mucCreateRoom: function(roomName) {
            Chat.mucSendPresence(roomName);
            Chat.connection.muc.createInstantRoom(roomName, function(status) {
                Chat.log("Succesfully created ChatRoom", status)
            }, function(status) {
                Chat.log("Error creating ChatRoom", status)
            })
        },
        mucSessionInfo: {},
        mucJoin: function(roomName, nickname, password) {
            nickname = nickname ? nickname : Chat.getSubJID(Chat.connection.jid);
            Chat.connection.muc.join(roomName, nickname, Chat.messageReceived, Chat.presenceReceived, Chat.rosterReceived, password);
            Chat.mucSessionInfo["roomName"] = roomName;
            Chat.mucSessionInfo["nickname"] = nickname
        },
        mucLeave: function(exitMessage) {
            Chat.connection.muc.leave(Chat.mucSessionInfo["roomName"], Chat.mucSessionInfo["nickname"], Chat.presenceReceived, exitMessage)
        },
        mucListRooms: function() {
            Chat.connection.muc.listRooms(Strophe.getDomainFromJid(Chat.connection.jid), function(status) {
                Chat.log("List of Chat Rooms", status)
            }, function(status) {
                Chat.log("Error getting Chat Rooms", status)
            })
        },
        log: function() {
            if (!Chat.connection) {
                console.log("Error, not connected`, please enter credentials:\n " + "Chat.connect('jid','password')")
            }
            if (Chat.debuggingMode) {
                for (var i = 0; i < arguments.length; i++) {
                  //console.log(arguments[i]);
                }
            }
        },
        getSubJID: function(Jid) {
            Jid = Jid ? Jid : Chat.connection.Jid;
            var subJID = "";
            for (i = 0; i < Jid.length; i++) {
                if (Jid[i] === "/") {
                    if (Chat.connected) Chat.log(Jid + " => " + subJID);
                    return subJID
                }
                subJID += Jid[i]
            }
            return subJID
        }
      };
    return {
        Chat: Chat
    }
});
